import "./Hero.scss";
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { getImageUrl } from '../../utils/imageAssets';


const Hero = () => {
  const navigate = useNavigate();
  const heroBg = getImageUrl("/images/home/04.jpg");

  return (
    <section className="hero" style={{ backgroundImage: `url(${heroBg})` }}>
      <div className="hero-overlay" />
        <div className="container hero-inner">
          <div className="hero-badge">GIST Student Ambassador GIONNARAE</div>
          
          <h1 className="hero-title">
            GIST를 온 세상에 널리 알리는 날개
            <br />
            <span className="hero-accent">공식 학생 홍보대사 지온나래</span>
          </h1>
          
          <p className="hero-sub">
            캠퍼스 투어부터 새내기 가이드, 그리고 홍보 콘텐츠까지 —
            <br />
            지온나래가 GIST의 매력을 더 가까이 전해요.
          </p>
          
          <div className="hero-actions">
            <button className="hero-btn primary" onClick={() => navigate('/about')}>지온나래 소개</button>
            <button className="hero-btn primary" onClick={() => navigate('/tour')}>캠퍼스 투어</button>
            <button className="hero-btn primary" onClick={() => navigate('/guide')}>새내기 가이드</button>
          </div>

      </div>
    </section>
  );
};

export default Hero;
